import { ModelContributionContext } from '@/dashboards/ModelContributions/providers';
import { useContext } from 'use-context-selector';

export const useModelContributionContext = () => {
    return useContext(ModelContributionContext);
};
